import { createFileRoute } from "@tanstack/react-router"
import { GroupDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/groups-committees/$groupUuid/$tabKey"
)({
  component: () => (
    <AuthorizationGate resource={Resource.GROUP} action={Action.READ}>
      <GroupDetailPage />
    </AuthorizationGate>
  ),
})
